import type { RenamePlan, TextEdit } from '@cli-types/core-engine/snapshots.js'
import type { SourceFile } from 'ts-morph'
import { quoteLiteral } from '@cli-utils/text.js'
import { Node } from 'ts-morph'
import { getTemplateReplacement } from './get-template-replacement.js'
import { replaceIdentifierValue } from './replace-identifier-value.js'
import { replaceStringLiteralValue } from './replace-string-literal-value.js'
import { replaceTemplateLiteralValue } from './replace-template-literal-value.js'

export function buildEditsForSourceFile(
  sourceFile: SourceFile,
  filePath: string,
  plan: RenamePlan
): TextEdit[] {
  const edits: TextEdit[] = []

  sourceFile.forEachDescendant((node) => {
    if (Node.isIdentifier(node)) {
      const next = replaceIdentifierValue(node.getText(), filePath, plan)
      if (next !== node.getText()) {
        edits.push({
          start: node.getStart(),
          end: node.getEnd(),
          replacement: next
        })
      }
      return
    }

    if (Node.isStringLiteral(node)) {
      const quote = node.getText().startsWith("'") ? "'" : '"'
      const next = replaceStringLiteralValue(node.getLiteralValue(), filePath, node, plan)
      if (next !== node.getLiteralValue()) {
        edits.push({
          start: node.getStart(),
          end: node.getEnd(),
          replacement: quoteLiteral(next, quote)
        })
      }
      return
    }

    if (Node.isNoSubstitutionTemplateLiteral(node)) {
      const next = replaceStringLiteralValue(node.getLiteralText(), filePath, node, plan)
      if (next !== node.getLiteralText()) {
        edits.push({
          start: node.getStart(),
          end: node.getEnd(),
          replacement: `\`${next}\``
        })
      }
      return
    }

    if (Node.isTemplateHead(node) || Node.isTemplateMiddle(node) || Node.isTemplateTail(node)) {
      const next = replaceTemplateLiteralValue(node.getLiteralText(), node, plan)
      if (next !== node.getLiteralText()) {
        edits.push({
          start: node.getStart(),
          end: node.getEnd(),
          replacement: getTemplateReplacement(node, next)
        })
      }
    }
  })

  return edits
}
